import {VoucherRegisterSummary} from "@app/shared/classes/voucher-register-summary";
import {PaymentRequest} from "@app/shared/ach/org-payment-transaction";
import {PaymentType} from "@app/shared/enums/payment-type.enum";

export class VoucherRegister {

  id?: number;
  version: number;
  paymentType: PaymentType;
  paymentDate: Date;
  paymentAmount: number;


  invoicePaymentId?: number;
  expenseId?: number;
  vendorName?: string;
  invoiceNumber?: string;
  invoiceId?: number;  //Transient Field
  paymentTxnRequest?: PaymentRequest;

  constructor(vrs?: VoucherRegisterSummary) {
    if (vrs) {
      this.paymentType = vrs.paymentType;
      this.paymentAmount = vrs.amountPaid;
      this.id = vrs.id;
      this.version = vrs.version;
      this.invoicePaymentId = vrs.invoicePaymentId;
      this.expenseId = vrs.expenseId;
      this.paymentDate = (vrs.invoicePaymentId) ? vrs.invoicePaymentDate : vrs.expensePaymentDate;
      }
    }
}

export enum VoucherRegisterTab {
  Invoice = 0,
  Expense = 1,
  TransactionHistory = 2
}
